export const SET_SHOW_MODAL = 'SET_SHOW_MODAL';
export const SET_MODAL_RESPONSE = 'SET_MODAL_RESPONSE';
export const RESET_MODAL = 'RESET_MODAL';

export const setShowLeaveTableModal = (_) => ({
    type: SET_SHOW_MODAL,
    payload: _,
});
export const setLeaveTableModalResponse = () => ({
    type: SET_MODAL_RESPONSE,
});
export const resetLeaveTableModal = () => ({
    type: RESET_MODAL,
});
